import { createColumn } from "./createColumn";
import { generateMonthColumns } from "./generateMonthColumns";

/**
 * @param {Array} columns
 * @param {Array} columnsAfterMonths
 * @param {Boolean} includeFiscalMonths
 * @param {Object} columnsMonthAdditionalArgs
 * @returns
 */
export const columnBuilder = (
  columns = [],
  columnsAfterMonths = [],
  includeFiscalMonths = false,
  columnsMonthAdditionalArgs = {},
) => {
  const generatedColumns = [];

  columns.forEach((column) => {
    generatedColumns.push(createColumn(column));
  });

  if (includeFiscalMonths) {
    generatedColumns.push(
      ...generateMonthColumns(columns, columnsMonthAdditionalArgs),
    );
  }

  columnsAfterMonths.forEach((column) => {
    generatedColumns.push(createColumn(column));
  });

  return generatedColumns;
};
